// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field-error{color:#a4262c;padding-top:5px}", "",{"version":3,"sources":["webpack://./resources/js/Components/Utilities/FieldError.vue"],"names":[],"mappings":"AACA,aAEE,aAAA,CADA,eACF","sourcesContent":["\n.field-error {\n  padding-top: 5px;\n  color: rgb(164, 38, 44);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
